import { createWebEnv } from "./env-schema";

export { createWebEnv } from "./env-schema";
export const env = createWebEnv(import.meta.env);
